// extracted by mini-css-extract-plugin
export default {"section":"Section-section-Ie-08"};